"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.departureCapacityColor = void 0;
const departureCapacityColor = (occurrence) => {
    const occupationPercentage = (occurrence.currentPeople * 100) / occurrence.maxPeople;
    if (occupationPercentage > 80) {
        return '#b44';
    }
    if (occupationPercentage > 60) {
        return 'orange';
    }
    return 'green';
};
exports.departureCapacityColor = departureCapacityColor;
//# sourceMappingURL=departureCapacityColor.js.map